module.exports = __webpack_public_path__ + "img/placeholder.fcc6bedc.svg";